const { get } = require("network/http/api")

export const getConversation = (id) => {
  return get(`/embed/v1/conversation/detail/${id}`)
}